/*!
 * Extending verge.js with support for percent height/width that are viewable.
 *
 * @author Peter Chanthamynavong <pchanthamynavong@blizzard.com>
 * @link https://github.com/ryanve/verge
 */

// The semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
//
// Reference: https://github.com/jquery-boilerplate/jquery-boilerplate/blob/master/src/jquery.boilerplate.js
;(function ($, window, document, undefined) {
    
    var plugin = {};
    
    /**
     * Test if an element is in the viewport.
     * @since 1.0.0
     * @param {Element|Object} el
     * @param {Object} options
     * @return {boolean}
     */
    plugin['isViewable'] = function(el, options) {
        
        var opts = _.defaults({}, options, {
            cushion : 0,
            percentH: 0.5,
            percentW: 0.5
        });
        
        opts.percentH = Math.max(0, opts.percentH);
        opts.percentW = Math.max(0, opts.percentW);
        
        // Equiv to `inX(el, cushion) && inY(el, cushion)` but just manually do both
        // to avoid calling rectangle() twice. It gzips just as small like this.
        var r = $.rectangle(el, opts.cushion);
        
        return $.inViewport(el, opts.cushion)
            && (r.top + r.height * opts.percentH) <= $.viewportH()
            && (r.left + r.width * opts.percentW) <= $.viewportW();
    };
    
    $.extend(window.verge);
    $.extend(plugin);
    
})(jQuery || window.$, window, document);
